export default __webpack_public_path__ + "static/media/date-pick.d547970c.svg";